module.exports = __webpack_public_path__ + "static/about-hero-7458ec7d4128f51fe6429a3daeec8e8e.jpg";